const USACyberLaw = () => {
  return (
    <div className='usa-cyber-law'>
      <h2>Key U.S. Cyber Law Statutes</h2>
      <p>
        In the United States, multiple federal statutes have been enacted to address cybercrimes and a wide range of
        cyber-related activities, from computer hacking and fraud to online harassment and intellectual property theft. Some
        of these key laws Include:
      </p>
      <h6>
        <strong>Computer Fraud and Abuse Act (CFAA) (18 U.S.C. § 1030)</strong>
      </h6>
      <p>
        Enacted in 1986 as an amendment to the first federal computer fraud law, the CFAA initially addressed hacking but
        has since been amended multiple times to address a broader range of conduct. The Act prohibits intentionally
        accessing a computer without authorization or in excess of authorization. However, because the CFAA fails to define
        precisely what "without authorization" means, civil libertarians assert that it could be used to criminalize nearly
        every aspect of computer activity, even those that most people consider innocuous.
      </p>
      <h6>
        <strong>Identity Theft and Assumption Deterrence Act (18 U.S.C. § 1028)</strong>
      </h6>
      <p>
        Enacted in 1998, the Identity Theft and Assumption Deterrence Act prohibits anyone from misusing another person's
        identifying information, whether personal or financial, including:
      </p>
      <ul>
        <li>Social Security numbers</li>
        <li>Credit card information</li>
        <li>Bank account information</li>
        <li>PIN numbers</li>
        <li>Driver's license numbers</li>
        <li>Birth or death certificates</li>
      </ul>
      <p>
        In 2004, the Act was amended to establish the offense of aggravated identity theft, which involves using another's
        information in connection with certain federal crimes or in relation to an act of terrorism.
      </p>
      <h6>
        <strong>Digital Millennium Copyright Act (DMCA)</strong>
      </h6>
      <p>
        Passed in 1998, the DMCA amended U.S. copyright law to address the relationship between copyright and the internet
        by:
      </p>
      <ol>
        <li>Establishing protections for online service providers in the event their users engage in copyright infringement.
        </li>
        <li>Encouraging copyright owners to give greater access to their works in digital formats by providing them with
          legal protections against unauthorized access.</li>
        <li>Making it unlawful to provide false copyright management information or to remove or alter that type of
          information in certain circumstances.</li>
      </ol>
      <h6>
        <strong>Child Online Privacy Protection Act (COPPA)</strong>
      </h6>
      <p>
        COPPA aims to protect the privacy of children under the age of 13 by requiring that website owners:
      </p>
      <ul>
        <li>Incorporate a detailed privacy policy detailing information collected from its users.</li>
        <li>Acquire verifiable parental consent before collection of personal information from a child under the age of 13.
        </li>
        <li>Disclose to parents any information collected on their children by the website.</li>
        <li>Allow parents to revoke consent and have information deleted at any time.</li>
        <li>Limit collection of personal information when a child participates in online games and contests.</li>
        <li>Protect the confidentiality, security, and integrity of any personal information collected online from children.
        </li>
      </ul>
    </div>
  );
};

export default USACyberLaw;